import React, { useState, useEffect } from "react";
import { Link, useSearchParams } from "react-router-dom";
import axios from "axios";

const API_BASE = "https://eluvent.com/api";

const StudyPlan = () => {
  const [searchParams] = useSearchParams();
  const sessionId = searchParams.get("session_id") || "";
  const [plan, setPlan] = useState("");
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!sessionId) {
      setError("No session ID. Please go to the chat first.");
      setLoading(false);
      return;
    }
    axios.post(`${API_BASE}/study-plan`, { session_id: sessionId })
      .then(res => setPlan(res.data.plan || "No plan available."))
      .catch(() => setError("Failed to load study plan."))
      .finally(() => setLoading(false));
  }, [sessionId]);

  if (!sessionId) {
    return (
      <div style={{ maxWidth: 600, margin: "100px auto", textAlign: "center", fontFamily: "Nunito, sans-serif" }}>
        <h2>📅 No session ID</h2>
        <p>Please access this from the main chat page.</p>
        <Link to="/" style={{ color: "#fca311", fontWeight: 700 }}>← Back to Chat</Link>
      </div>
    );
  }

  if (loading) return <div style={{ textAlign: "center", padding: 40 }}>Creating your personalized plan...</div>;
  if (error) return <div style={{ textAlign: "center", padding: 40, color: "red" }}>{error}</div>;

  return (
    <div style={{ maxWidth: 700, margin: "40px auto", padding: 20, fontFamily: "Nunito, sans-serif" }}>
      <h1 style={{ color: "#1e293b", textAlign: "center" }}>📅 Your Personalized Study Plan</h1>
      <div style={{ background: "white", borderRadius: 20, padding: 20, boxShadow: "0 2px 8px rgba(0,0,0,0.04)", whiteSpace: "pre-wrap", lineHeight: 1.6 }}>
        {plan}
      </div>
      <div style={{ textAlign: "center", marginTop: 20 }}>
        <Link to="/" style={{ padding: "10px 20px", background: "#fca311", color: "white", borderRadius: 30, textDecoration: "none", fontWeight: 700 }}>← Back to Chat</Link>
      </div>
    </div>
  );
};

export default StudyPlan;